import { useEffect, useRef } from 'react'

/**
 * Gọi `callback` mỗi `intervalMs` khi `enabled`. Luôn gọi bản `callback` mới nhất (không cần đưa vào deps),
 * nên interval không bị khởi tạo lại mỗi lần render.
 */
export default function usePolling(callback, intervalMs, { enabled = true } = {}) {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    if (!enabled || !intervalMs) return undefined
    const id = setInterval(() => callbackRef.current(), intervalMs)
    return () => clearInterval(id)
  }, [enabled, intervalMs])
}
